import styled from 'styled-components';

import { CircleTick, CircleAttention } from "../Icons";
import { Hint } from "../Hint";

export const Container = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Container", componentId: "sc-1vgdtfq-0" })(["padding:4px 16px;display:flex;flex-direction:column;background-color:", ";"],



(props) => props.theme.colors.Background);


export const Delimiter = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__Delimiter", componentId: "sc-1vgdtfq-1" })(["background-color:", ";height:2px;margin-top:10px;margin-bottom:12px;"],
(props) => props.theme.colors['Level 1']);





export const StyledHint = /*#__PURE__*/styled(Hint).withConfig({ displayName: "styles__StyledHint", componentId: "sc-1vgdtfq-2" })(["width:initial;"]);



export const CircleTickIcon = /*#__PURE__*/styled(CircleTick).withConfig({ displayName: "styles__CircleTickIcon", componentId: "sc-1vgdtfq-3" })(["transform:scale(1.2);"]);



export const CircleAttentionIcon = /*#__PURE__*/styled(CircleAttention).withConfig({ displayName: "styles__CircleAttentionIcon", componentId: "sc-1vgdtfq-4" })(["transform:scale(1.2);"]);